import React from "react";
import "./Skills.css";
import "./Services.css";

import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import { message } from "antd";

import PDF from "../Data/Resume.pdf";

export default function Skills() {
  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi
      .open({
        type: "loading",
        content: "Downloading..",
        duration: 2.5,
      })
      .then(() => {
        const link = document.createElement("a");
        link.href = PDF;
        link.download = "Resume.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Download successful", 2.5);
      });
  };

  const success2 = () => {
    messageApi
      .loading({
        content: "Get Ready...",
        duration: 1.5,
      })
      .then(() => {
        window.open(PDF, "_blank");
        message.success("Get Ready", 2.5);
      });
  };
  return (
    <div className="Skills-Body">
      {contextHolder}
      <div className="Skills-Box1">
        <div className="Skills-Left">
          <p className="Services-Text1">|| Special Skills</p>
          <p className="Services-Text2">My Special Skill Field Here.</p>

          <button className="Skills-Left-Button" onClick={success2}>
            View Resume
            <EyeOutlined />
          </button>

          <button className="Skills-Left-Button" onClick={success}>
            Get Resume
            <DownloadOutlined />
          </button>
        </div>
        <div className="Skills-Right">
          <div className="Skills-Right-Box">
            <div className="Skills-Right-Div">
              <p>Communication</p>
              <p>75%</p>
            </div>

            <div className="Skills-Right-Line1">
              <div className="Skills-Right-Line2" />
            </div>
          </div>

          <div className="Skills-Right-Box">
            <div className="Skills-Right-Div">
              <p>Leadership</p>
              <p>70%</p>
            </div>

            <div className="Skills-Right-Line1">
              <div className="Skills-Right-Line3" />
            </div>
          </div>

          <div className="Skills-Right-Box">
            <div className="Skills-Right-Div">
              <p>Teamwork</p>
              <p>90%</p>
            </div>

            <div className="Skills-Right-Line1">
              <div className="Skills-Right-Line4" />
            </div>
          </div>

          <div className="Skills-Right-Box">
            <div className="Skills-Right-Div">
              <p>Flexibility</p>
              <p>80%</p>
            </div>

            <div className="Skills-Right-Line1">
              <div className="Skills-Right-Line5" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
